// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { CommissionGroup, DirectMarginMessage, MarginGroup } from '@shared/utils/DirectMessages/DirectMarginMessage';
import { CommissionOperationType } from '@shared/utils/Commission/CommissionEnums';
export class MarginResponseMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectMarginMessage();
        const groups = fieldSet.GetGroups(FieldsFactory.MARGIN_GROUP);
        this.processResponse(message, groups);
        return [message];
    }
    parseCommissions(commissionGroups) {
        if (!commissionGroups) {
            return;
        }
        const result = [];
        for (let i = 0; i < commissionGroups.length; i++) {
            const group = commissionGroups[i];
            const resGroup = new CommissionGroup();
            resGroup.CommissionType = group.GetValue(FieldsFactory.FIELD_COMMISSION_TYPE);
            resGroup.OperationType = group.GetValue(FieldsFactory.FIELD_TYPE);
            resGroup.Amount = group.GetValue(FieldsFactory.FIELD_AMOUNT);
            resGroup.CurrencyId = group.GetValue(FieldsFactory.FIELD_ASSET_ID);
            result.push(resGroup);
        }
        return result;
    }
    processResponse(message, groups) {
        for (let g = 0; g < groups.length; g++) {
            const group = groups[g];
            const len = group.fieldSet.length;
            const operationMode = group.GetValue(FieldsFactory.FIELD_OPERATION_MODE);
            const isBuy = operationMode === CommissionOperationType.BUY;
            const marginGroup = new MarginGroup();
            const targetGroup = isBuy ? message.BuyGroup : message.SellGroup;
            const commissionGroups = group.GetGroups(FieldsFactory.COMMISSION_RESPONSE_GROUP);
            if (commissionGroups) {
                message.CommissionsByOperationMode[operationMode] = this.parseCommissions(commissionGroups);
            }
            // buying power name #106952
            const name = group.GetValue(FieldsFactory.FIELD_NAME);
            if (name) {
                message.BuyingPowerName = name;
            }
            const offMarketEnabled = group.GetValue(FieldsFactory.FIELD_OFFMARKET_ENABLED);
            if (offMarketEnabled) {
                marginGroup.OffMarketEnabled = offMarketEnabled;
            }
            for (let i = 0; i < len; i++) {
                const fixField = group.fieldSet[i];
                const fieldID = fixField.FieldId;
                const fieldValue = fixField.Value;
                if (fieldID === 0) {
                    continue;
                }
                switch (fieldID) {
                    case FieldsFactory.FIELD_BUY_INIT:
                    case FieldsFactory.FIELD_SELL_INIT:
                        marginGroup.InitMargin = targetGroup.InitMargin = fieldValue;
                        break;
                    case FieldsFactory.FIELD_BUY_SUPP:
                    case FieldsFactory.FIELD_SELL_SUPP:
                        marginGroup.MaintMargin = targetGroup.MaintMargin = fieldValue;
                        break;
                    case FieldsFactory.FIELD_SHORT_SWAP_INFO:
                        message.ShortSwapInfo = fieldValue;
                        break;
                    case FieldsFactory.FIELD_SWAP_BUY:
                        message.SwapBuy = fieldValue;
                        break;
                    case FieldsFactory.FIELD_SWAP_SELL:
                        message.SwapSell = fieldValue;
                        break;
                    case FieldsFactory.FIELD_AVAILABLE_FUNDS:
                        targetGroup.AvailableFunds = fieldValue;
                        break;
                    case FieldsFactory.FIELD_AFTER_TRADE_CASH:
                        marginGroup.EstAvailableCash = message.EstAvailableCash = fieldValue;
                        break;
                    case FieldsFactory.FIELD_TOTAL_FEE:
                        marginGroup.TotalFee = targetGroup.TotalFee = fieldValue;
                        break;
                    case FieldsFactory.FIELD_AFTER_TRADE_FUNDS:
                        marginGroup.AfterTradeFunds = targetGroup.AfterTradeFunds = fieldValue;
                        break;
                    case FieldsFactory.FIELD_IMPACT_ON_FUNDS:
                        marginGroup.ImpactOnFunds = targetGroup.ImpactOnFunds = fieldValue;
                        break;
                    case FieldsFactory.FIELD_AFTER_TRADE_MARGIN:
                        marginGroup.AfterTradeMargin = targetGroup.AfterTradeMargin = fieldValue;
                        break;
                    case FieldsFactory.FIELD_IMPACT_ON_MARGIN:
                        marginGroup.ImpactOnMargin = targetGroup.ImpactOnMargin = fieldValue;
                        break;
                    case FieldsFactory.FIELD_FREE_COMMISSION_AMOUNT:
                        message.FreeCommission = fieldValue;
                        break;
                    case FieldsFactory.FIELD_AMOUNT:
                        marginGroup.Amount = targetGroup.Amount = fieldValue;
                        break;
                    case FieldsFactory.FIELD_CASH_ORDER_QTY:
                        marginGroup.Cash = targetGroup.Cash = fieldValue;
                        break;
                }
            }
            message.Groups.push(marginGroup);
        }
    }
}
